/**
 * GST-inclusive fee split mirrors {@code ValuationFeePaymentService.baseFromTotalInclGst}
 * for the valuation payable (base + GST).
 */
const JAVA_BASE_FROM_TOTAL_PROPORTION_NUMERATOR = 9174311927;
const JAVA_BASE_FROM_TOTAL_PROPORTION_DENOMINATOR = 10000000000;

function toCents(value: number): number {
  const [whole, fraction = ''] = String(value).split('.');
  const cents = `${fraction}00`.slice(0, 2);
  return Number(whole) * 100 + Number(cents);
}

function centsToNumber(cents: number): number {
  return cents / 100;
}

function divideHalfEven(numerator: number, denominator: number): number {
  const quotient = Math.trunc(numerator / denominator);
  const remainder = numerator % denominator;
  const doubledRemainder = remainder * 2;

  if (doubledRemainder < denominator) {
    return quotient;
  }
  if (doubledRemainder > denominator) {
    return quotient + 1;
  }
  return quotient % 2 === 0 ? quotient : quotient + 1;
}

function baseFromTotalInclGstCents(totalInclGstCents: number): number {
  return divideHalfEven(
    totalInclGstCents * JAVA_BASE_FROM_TOTAL_PROPORTION_NUMERATOR,
    JAVA_BASE_FROM_TOTAL_PROPORTION_DENOMINATOR
  );
}

/** GST-inclusive valuation fee (single payable amount). */
export function buildValuationFeeCreditLineAmounts(valuationFeeInclGst: number): number[] {
  const total = toCents(valuationFeeInclGst);
  const valuationBase = baseFromTotalInclGstCents(total);
  const valuationGst = total - valuationBase;

  const amounts = [valuationBase, valuationGst];
  const sum = amounts.reduce((acc, v) => acc + v, 0);
  amounts[1] = amounts[1] + (total - sum);

  return amounts.map(centsToNumber);
}
